// extracted by mini-css-extract-plugin
export var container = "_23-0";
export var disabled = "_23-4";
export var fullWidth = "_23-3";
export var lined = "_23-1";
export var selected = "_23-5";
export var tab = "_23-2";